<template>
  <div class="ma-4">
  <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
  <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
            <v-flex xs12>
              <v-btn fab x-small @click="$router.go(-1)">
                <v-icon>navigate_before</v-icon>
                  
                </v-btn>
            </v-flex>

            <!-- <v-flex xs12 md1 class="mb-2">
              <v-btn 
                  fab 
                  small
                  @click="printTable()"
                  class="ml-8 white--text"
                  color="#2b6993"
                  elevation="4"
                  absolute 
                  right
                  >
                  <v-icon>print</v-icon>
              </v-btn>
            </v-flex> -->

            <v-flex xs12>
              <h3 class="text-center mb-5">Ancillary Report</h3>
              <v-divider class="ml-4 mr-4 mb-3"></v-divider>
            </v-flex>

            <v-flex xs12>
              <v-card
                class="ma-3 pa-3"
                elevation="0"
              >
                <v-layout row wrap>
                  <v-flex xs12 md3 class="pa-1" >
                    <v-menu
                        ref="calendarMenu"
                        v-model="calendarMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            @change="getQueryData"
                            v-model="startDate"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules='requiredField'
                            clearable
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="startDate"
                        no-title
                        scrollable
                        :rules='requiredField'

                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="calendarMenu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.calendarMenu.save(date)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-menu>
                    
                </v-flex>

                <v-flex xs12 md3 class="pa-1 hideOnPrint">
                  <v-menu
                        ref="calendar2Menu"
                        v-model="calendar2Menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            @change="getQueryData"
                            v-model="endDate"
                            label="End Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules='requiredField'
                            clearable

                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="endDate"
                        no-title
                        scrollable
                        :rules='requiredField'

                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="calendar2Menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.calendar2Menu.save(date)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs12 md3 class="pa-1 mb-2 hideOnPrint">
                  <v-select
                      @change="getQueryData"
                      label="Select a Client"
                      :items="clients"
                      item-text="Name"
                      item-value="_id"
                      v-model="clientID"
                      clearable
                      :required="requiredField"
                  ></v-select>
                </v-flex>

                <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                    <!-- <v-btn 
                      fab 
                      small
                      @click="printTable()"
                      class="mr-8 mb-2 white--text"
                      color="#2b6993"
                      elevation="4"
                      >
                      <v-icon>print</v-icon>
                  </v-btn> -->

                  <v-btn 
                      small 
                      @click="getQueryData()"
                      class="ma-1"
                      
                      >Search</v-btn>
                  <!-- <v-btn
                      small
                      @click="downloadMarCSV()"
                      class="ma-1"

                  >Export</v-btn> -->

            
                <!-- <v-menu offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      class="white--text"
                      v-bind="attrs"
                      v-on="on"
                      color="blue-grey"
                      small
                      :loading="isDownloading"
                      :disabled="isDownloading"
                    >
                      Export
                      <v-icon right dark> mdi-cloud-download </v-icon>
                    </v-btn>
                  </template>

                  <v-list class="pa-0">
                    <v-list-item
                      v-for="(item, index) in reportItems"
                      :key="index"
                      link
                    >
                      <v-list-item-title
                        v-text="item"
                        @click="download(item)"
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
       


                </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-dialog v-model="dialog" max-width="100%">
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form
                        ref="form"
                        lazy-validation
                      >
                      <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="newDate"
                                    label="Date of Service"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="newDate"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(newDate)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                  label="Area of Protective Oversight"
                                  :items="oversights"
                                  v-model="newOversight"
                                  :rules="requiredField"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" v-if="newOversight == 'Other'">
                              <v-textarea
                                label="Other"
                                v-model="newOther"
                                outlined
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    label="Time/Hours"
                                    v-model="newTime"
                                    :items="times"
                                    :rules="requiredField"
                                ></v-select>
                            </v-col>                 
                            
                        </v-row>
                      </v-container>
                      </v-form>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="white--text"
                        color="#259647"
                        @click="addAncillary()"
                        v-if="newAncillary"
                        >Save</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="updateAncillary()"
                        v-if="editAncillary"
                        >Update</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
            


            <v-flex xs12 class="pa-2 hideOnPrint">
                <v-data-table
                    :headers="headers"
                    :items="ancillaries"
                    sort-by="Date"
                    sort-desc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Ancillary Logs"

                >
                <template v-slot:item.actions="{ item }">
                    <v-btn
                      x-small
                      class="white--text"
                      color="#2b3990"
                      @click="viewAncillary(item)"
                    >
                      view
                    </v-btn>
                </template>
                </v-data-table>

            </v-flex>
          </v-layout>
        </v-card>
        <div id="printTable">
          <h2 class="text-center">Ancillary Log Report</h2>
            <v-row row wrap>
                <v-col cols="4">
                  <v-text-field
                      v-model="startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      :rules='requiredField'
                      clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                      v-model="endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      :rules='requiredField'
                      clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select 
                      label="Select a Client"
                      :items="clients"
                      item-text="Name"
                      item-value="_id"
                      v-model="clientID"
                      clearable
                      :rules="requiredField"
                  ></v-select>
                </v-col>
                <v-col cols='12'>
                    
                  <v-data-table
                      :headers="headers"
                      :items="ancillaries"
                      sort-by="Date"
                      sort-asc
                      class="elevation-1"
                      :loading="isLoading"
                      loading-text="Loading Ancillary Logs"
                      :items-per-page="-1"

                  >
                  <!-- <template v-slot:item.select="{ item }">
                      <v-btn
                          x-small
                          class="white--text"
                          color="#2b3990"
                          @click="viewMAR(item)"
                      >
                          view
                      </v-btn>         
                  </template> -->
                  </v-data-table>

              </v-col>
            </v-row>
        </div>
  </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
import { mapActions } from 'vuex';
import momentTz from 'moment-timezone';
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

export default {
  components: {
  },
  data: () => ({
  headers: [
    {
      text: "Date",
      align: "start",
      sortable: false,
      value: "Date",
    },
    { text: "Client", value: "ClientID.Name"},
    { text: "Oversight", value: "Oversight"},
    { text: "Time/Hours", value: "Time"},
    { text: "Actions", value: "actions", sortable: false },
  ],
  date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
  startDate: "",
  endDate: "",
  menu: false,
  dialog: false,
  editAncillary: false,
  newAncillary: false,
  msg: false,
  search: "",
  text: "",
  ancillaries: [],
  clients: [],
  tempData: [],
  clientID: "",
  titleForm: "New Ancillary Log",
  ancillaryID: "",
  newDate: "",
  newTime: "",
  newOversight: "",
  newOther: "",
  oversights: [
    "Medical",
    "Transportation",
    "Other",
  ],
  times: [
    .25,
    .50,
    .75,
    1.00,
    1.25,
    1.50,
    1.75,
    2.00,
    2.25,
    2.50,
    2.75,
    3.00,
    3.25,
    3.50,
    3.75,
    4.00,
    4.25,
    4.50,
    4.75,
    5.00,
    5.25,
    5.50,
    5.75,
    6.00,
    6.25,
    6.50,
    6.75,
    7.00,
    7.25,
    7.50,
    7.75,
    8.00,
    8.25,
    8.50,
    8.75,
    9.00,
    9.25,
    9.50,
    9.75,
    10.00,

  ],
  requiredField: [
      v => !!v || 'This is required',
  ],
  isDownloading: false,
  isLoading: false,
  userState: localStorage.getItem('userState'),
  reportItems: ['Excel', 'PDF'],
  }),

  computed: {
    
  },

  watch: {
    // options: {
    //   handler() {
    //     this.getMars();
    //   },
    //   deep: true
    // }
  },

  created() {
    this.getClients();
    this.getAncillaries();
  //   this.getPrograms();
  },

  methods: {
    ...mapActions({
      downloadAncillaryReport: "ancillary/downloadAncillaryReport"
    }),
    initialize() {
      this.clients = [];
    },

    getClients() {
            if (this.userState) {
                return axios.get(`${url}/clients/status/state/nevada/active`).then(async res => {
                    this.clients = res.data.clients;
                });
            }

            // axios.get(`${url}/clients/`).then(async res => {
            //     this.clients = res.data.clients;
            //   });
        },


    close() {
      this.dialog = false;
      this.seditInfo = false;
      this.passdialog = false;
      this.chgimg = false;

    },

    // getAncillaries() {
    //   let { page, itemsPerPage } = this.options;
    //   page = page || 1;
    //   itemsPerPage = 100;
    //   this.isLoading = true;

    //   axios.get(`${url}/ancillary/report?page=${page}&limit=${itemsPerPage}&state=${this.userState}`).then(response => {
    //     const { docs, totalPages, totalDocs } = response.data;

    //     if(this.userState){
    //       if (docs && docs.length > 0) {
    //         this.mars = docs.filter(doc => this.userState === doc.ClientID.State).map(doc => {
    //           doc.Date = moment(doc.Date).format("MM/DD/YYYY");
    //           return doc;
    //         });
    //       }
    //     }else{
    //       this.mars = docs
    //     }


    //     this.pageCount = totalPages;
    //     this.itemCount = totalDocs;
    //     this.isLoading = false;
    //   })
    // },

    getAncillaries: function() {
        this.isLoading = true;
        this.ancillaries = [];
        axios.get(`${url}/ancillary`).then(res => {
          this.ancillaries = res.data.ancillaries
        })
        .finally(() => (this.isLoading = false));
      },


    getQueryData() {
      this.isLoading = true
      console.log({id: this.clientID})
      if(this.clientID == ''){
        axios.get(`${url}/ancillary/report/${this.startDate}/${this.endDate}`).then(res => {
          this.ancillaries = res.data.ancillaries
        })
        .finally(() => (this.isLoading = false));
        
      } else {
        axios.get(`${url}/ancillary/report/${this.startDate}/${this.endDate}/${this.clientID}`).then(res => {
          this.ancillaries = res.data.ancillaries

        })
        .finally(() => (this.isLoading = false));
      }
      
    },

    downloadMarCSV() {
      const startDate = new Date(`${this.startDate}`).toISOString()
      const endDate = new Date(`${this.endDate}`).toISOString()
      window.location.href = `${url}/mar/download?clientId=${this.clientID}&startDate=${startDate}&endDate=${endDate}`;
    },

    async downloadMarPDF() {
      this.isDownloading = true
      const startDate = new Date(`${this.startDate}`).toISOString()
      const endDate = new Date(`${this.endDate}`).toISOString()
      const tz = momentTz.tz.guess();

      const data = {
        startDate,
        endDate,
        clientId: this.clientID,
        tz
      }
      try {
        const response = await this.downloadMARReport(data)
        if(response.status === 400){
          this.isDownloading = false
          return alert('Unable to download report')
        }
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'mar-summary-report.pdf')
        document.body.appendChild(link)
        link.click()
        this.isDownloading = false
      } catch (error) {
        this.isDownloading = false
        console.log(error)
      } 

    },

    download(docs){
      if(docs === 'Excel'){
       this.downloadMarCSV()
      }else{
        this.downloadMarPDF()
      }
    },

    updateAncillary() {
        var req_body = {
          Date: this.newDate,
          Time: this.newTime,
          Oversight: this.newOversight,
          Other: this.newOther,
        };
        axios
          .put(`${url}/ancillary/${this.ancillaryID}`, req_body)
          .then((response) => {
            this.getAncillary();
            if (response.status == 400) {
              response.json().then(function(data) {
                alert(data.msg);
              });
            }
            this.clear()
            this.msg = true;
            this.text = "The record has been updated successfully.";
          });
        this.close();
      },

    getClientID(item) {
      this.client = item.ClientID._id;
      window.localStorage.setItem('clientId', this.client)
      console.log(this.client)
    },

    printTable() {
      
      window.print()
    
  },

    printItem() {
      document.getElementById('printTable').style.display = "none";
    
      window.print()
  },

    viewAncillary(item) {
      this.titleForm = "Viewing Ancillary Log"
        this.dialog = true;
        this.editAncillary = true;
        this.newAncillary = false;
        this.newDate = item.Date;
        this.newTime = item.Time;
        this.newOversight = item.Oversight;
        this.newOther = item.Other;
        this.ancillaryID = item._id;
    },
  }
}
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

#printTable{
  display: none;
}

#printItem{
  display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  @media print { 
    #printTable{ 
    display: block; 
    border: none; 
    width: 1300px;
    padding-right: 300px;
    margin-left: -200px;

    }
   
    .hideOnPrint {
      display: none;
      border: none; 
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none; 

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  
    
  } 
</style>
